import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import Joi from 'joi-browser';
import Helmet from 'react-helmet';
// eslint-disable-next-line no-unused-vars
import parts from '../utilities/parts';

import { isNullOrEmpty, deleteControlCode } from '../utilities/stringUtil';

import _slideLoader from '../utilities/slideLoader'; // スライド
import EventMg from '../utilities/EventManager';
import { messageUtility } from '../utilities/messageUtility';
import { isPartnerCompanyRoleId } from '../utilities/roleUtility';
import regex from '../utilities/validateRegex'; // validation pattern
import { validateByJoi } from '../utilities/validation';
import {
  WORK_HOUR_ZONES, // 作業時間帯
  GATE_PASSAGES_STATUS_CODE, // ゲート予定ステータス
  SPOT_STATUS, // スポット利用ステータス
  SPOT_TIMES_DEFAULT,
  SCHEDULE_TYPES, // 予定種別
  HEADER_CONSTANTS, // ヘッダータイトル
  APPROVAL_STATUS, // 承認状態
} from '../utilities/constants'; // 定数ファイル

import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { CraneService } from '../services/Cranes'; // 揚重機マスタAPI
import { GatePassageService } from '../services/GatePassages'; // ゲート予定API
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import { GatePassageForm } from '../components/forms/GatePassages'; // ゲート予定フォーム
import Confirmation from '../components/modals/common/Confirmation';
import dialogLoader from '../utilities/dialogLoader';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';

import {
  isConcurrentErrorTracker,
  isPrimeContractorHasBlockedOrFinishedWorkError,
  isWorkDateError,
} from '../utilities/apiErrorMessage';
import { ConferencePageHeader } from '../components/PageHeader';
import { FormInformationDialog } from '../components/FormInformationDialog';
import {
  REQUIRED_INPUT_WITH_FUTRAL_HAS_SPOT,
  REQUIRED_INPUT_WITH_FUTRAL,
} from './GatePassageRegister';
import {
  isEditConcurrentErrorGate,
  isStatusRejectGateFutral,
} from '../utilities/gatePassageUtil';

const MY_EVENT = {
  LOAD_GATE_PASSAGES_DATA: 'load_gate_passages_data', // 一覧取得
};

// ダイアログ名
const DIALOG_NAME = {
  close: 'close', // クローズ
  delete: 'delete', // 削除
};

const INITIAL_REQUIRED_INPUT_COLUMNS = [
  'passage_date',
  'field_tree_id',
  'gate_id',
  'status_code',
  'truck_count',
  'luggage',
  'passage_start_time',
];

const INITIAL_REQUIRED_INPUT_HAS_SPOT = [
  'passage_date',
  'spot_company_name',
  'gate_id',
  'status_code',
  'truck_count',
  'luggage',
  'passage_start_time',
];

const REQUIRED_INPUT_WITH_CRANE = ['crane_work_contents', 'use_start_time'];

/**
 * @description ゲート予定編集画面
 */
export class GatePassageEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gatePassageId: this.props.view.state.id,
      fieldId: SessionStorageService.getFieldId(),
      roleId: LocalStorageService.getRoleId(),
      companyId: SessionStorageService.getCompanyId(),
      workTime: {}, // 現場に設定されている作業時間を格納
      visibleDialogName: null, // 開閉用ダイアログ名
      requiredInput: {
        columns: [...INITIAL_REQUIRED_INPUT_COLUMNS], // 必須入力項目名
        hasSpot: [...INITIAL_REQUIRED_INPUT_HAS_SPOT], // スポット業者あり必須入力項目名
        count: 3, // 期間・ステータス・台数は初期セット
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      isSpot: false, // スポット利用（フォームの切り替えで使用）
      isSpotToggle: false, // スポット業者切替フラグ
      isFirstLoaded: false, // 初回ロードフラグ
      viewOnlyFlag: false, // 閲覧制限フラグ
      // プルダウンの初期name
      pulldownName: {
        company_name: '', // 協力会社名
        job_name: '', // 職種名
        foreman_user_name: '', // 職長名
        gate_name: '', // ゲート名
        manager_user_name: '', // 元請担当者名
        crane_name: '', // 使用揚重機
        transportation_group_name: '',
      },
      formValues: {
        id: null,
        gate_fleet_status: null,
        gate_fleet_message: '',
        enter_gate_fleet_system_route_id: null,
        exit_gate_fleet_system_route_id: null,
        enter_gate_fleet_system_route_name: null,
        exit_gate_fleet_system_route_name: null,
        foreman_user_tel: null,
        userValueChangeFlag: false, // ユーザー操作フラグ
        approval_flag: APPROVAL_STATUS.unapproved.id, // 承認フラグ
        today_receipt_no: '', // 受付番号
        passage_date: '', // 日付
        field_tree_id: null, // 車輌手配業者
        job_id: null, // 職種
        foreman_user_id: null, // 職長
        spot_company_name: '', // スポット利用会社名
        spot_foreman_user_job: '', // スポット対象職種
        spot_foreman_user_name: '', // スポット利用職長名
        gate_id: null, // ゲート
        status_code: GATE_PASSAGES_STATUS_CODE.carry.id, // ステータス
        truck_name: '', // 車輌名
        truck_count: 1, // 台数
        luggage: '', // 荷種
        passage_start_time: '', // 開始時間
        passage_end_time: '', // 終了時間
        spot_flag: SPOT_STATUS.normal.id, // スポット作業ON/OFF
        spot_time: '5', // スポット時間
        manager_user_id: null, // 元請担当者
        crane_id: null, // 揚重機ID // ドロップダウンからnullが入るケースあり
        company_name: '', // 揚重機管理会社名
        operator_name: '', // オペレーター
        spec_form: '', // 性能
        crane_use_id: '', // 揚重機予定ID
        crane_work_contents: '', // 揚重機作業内容
        use_start_time: '', // 揚重機開始時間
        use_end_time: '', // 揚重機終了時間
        crane_spot_flag: '', // スポット作業ON/OFF
        crane_spot_time: '', // スポット時間
        tel: '', // 連絡先
        drivers_name: '', // 運転者名
        control_company_name: '', // 運用会社名
        memo: '', // 備考
        work_hour_zone: SessionStorageService.getItem('work_hour_zone'), // 作業時間帯
        schedule_type: SCHEDULE_TYPES.gate.id, // ゲート予定
        vehicle_numbers: [],
        transportation_group_id: null,
        sub_tel: '',
      },
      useConstructionSiteCodeFlg: false,
      limitTruckCount: 0,
      useTrackerFlg: false,
    };

    this.events = {
      form: {
        set: this.setFlatData.bind(this),
        setTime: this.setTime.bind(this), // 開始・終了時間セット
        update: this.update.bind(this),
        setSpot: this.setSpotFlag.bind(this),
        setSpotStatus: this.setSpotStatus.bind(this),
        setCraneSpotStatus: this.setCraneSpotStatus.bind(this),
        calender: this.setDate.bind(this),
        crane: this.setCraneDropdownData.bind(this),
        validate: this.validateValue.bind(this), // バリデーション
        setLuggageType: this.setLuggageType,
      },
    };

    this.updatingFlag = false; // 多重更新防止Flag

    this.setCraneDetails = this.setCraneDetails.bind(this); // 揚重機詳細取得
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視
    this.deleteGatePassage = this.deleteGatePassage.bind(this); // 予定削除
  }

  /**
   * 現場情報を取得し、作業時間をセット
   */
  componentDidMount() {
    FieldService.info(this.state.fieldId).then(response => {
      if (response.result) {
        const field = response.data.entities.field;
        const workTime = _.cloneDeep(this.state.workTime);
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { start: field.work_start_time }
        ); // 労働開始時刻（昼）
        workTime[WORK_HOUR_ZONES.day.id] = _.assign(
          workTime[WORK_HOUR_ZONES.day.id],
          { end: field.work_end_time }
        ); // 労働終了時刻（昼）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { start: field.work_start_time_night }
        ); // 労働開始時刻（夜）
        workTime[WORK_HOUR_ZONES.night.id] = _.assign(
          workTime[WORK_HOUR_ZONES.night.id],
          { end: field.work_end_time_night }
        ); // 労働終了時刻（夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { start: field.work_start_time_midnight }
        ); // 労働開始時刻（深夜）
        workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
          workTime[WORK_HOUR_ZONES.midnight.id],
          { end: field.work_end_time_midnight }
        ); // 労働終了時刻（深夜）
        const requiredInput = _.cloneDeep(this.state.requiredInput);
        if (field.use_construction_site_code_flag) {
          requiredInput.columns = [
            ...requiredInput.columns,
            ...REQUIRED_INPUT_WITH_FUTRAL,
          ];
          requiredInput.hasSpot = [
            ...requiredInput.hasSpot,
            ...REQUIRED_INPUT_WITH_FUTRAL_HAS_SPOT,
          ];
        }
        this.setState({
          workTime,
          requiredInput,
          useConstructionSiteCodeFlg: field.use_construction_site_code_flag,
          useTrackerFlg: !!field.use_tracker_flg,
        });
        GatePassageService.show(
          this.state.fieldId,
          this.state.gatePassageId
        ).then(response => {
          if (response.result) {
            this.initForm(response.data.entities.gate_passage);
          }
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // 機材予定編集画面でスポット業者へ切り替えを行った場合、一度だけ実行
    if (prevState.isSpot !== this.state.isSpot) {
      if (!this.state.isSpotToggle) {
        const pulldownName = { ...this.state.pulldownName };
        delete pulldownName.company_name;
        this.setState({ isSpotToggle: true, pulldownName });
      }
    }
  }

  /**
   * 必須入力状況チェック
   * @param values {object} 入力値
   */
  checkRequired(values) {
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    let cnt = 0;
    const columns = this.state.isSpot
      ? requiredInput.hasSpot
      : requiredInput.columns;
    _.each(columns, column => {
      if (values[column]) {
        if (
          _.includes(['foreman_user_tel', 'tel', 'sub_tel'], column) &&
          !regex.pattern.tel.test(values[column])
        ) {
          return;
        }
        cnt++;
      }
    });
    requiredInput.count = cnt;

    this.setState({ requiredInput });
  }

  /**
   * 入力値の有効判定
   * @param formValues {object}
   * @return bool
   */
  validateValue(name, updateValues = {}) {
    // 編集権限がない場合、エラーチェックは行わない
    if (this.state.viewOnlyFlag) {
      return;
    }
    const checkValues = {
      ...this.state.formValues,
      ...updateValues,
    };
    const { useConstructionSiteCodeFlg, useTrackerFlg } = this.state;
    const values = {};
    _.map(checkValues, (value, index) => {
      values[index] = _.isNull(value) ? '' : `${value}`;
    });

    // 基本項目
    const schema = {
      approval_flag: Joi.string().allow(null, ''), // 承認フラグ
      today_receipt_no: Joi.string()
        .allow(null, '')
        .max(255), // 受付番号
      passage_date: Joi.string().required(), // 開始日
      field_tree_id: Joi.string().allow(null, ''), // 車輌手配業者
      job_id: Joi.string().allow(null, ''), // 職種
      foreman_user_id: Joi.string().allow(null, ''), // 職長
      spot_company_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用会社名
      spot_foreman_user_job: Joi.string()
        .max(255)
        .allow(null, ''), // スポット対象職種
      spot_foreman_user_name: Joi.string()
        .max(255)
        .allow(null, ''), // スポット利用職長名
      gate_id: Joi.string().required(), // ゲート
      status_code: Joi.string().required(), // ステータス
      truck_name: Joi.string()
        .max(255)
        .allow(null, ''), // 車輌名
      truck_count: Joi.string().required(), // 台数
      luggage: Joi.string()
        .max(255)
        .required(), // 荷種
      passage_start_time: Joi.string().required(), // 開始時間
      passage_end_time: Joi.string().required(), // 終了時間
      spot_flag: Joi.number().required(), // スポット作業ON/OFF
      spot_time: Joi.string().allow(null, ''), // スポット時間
      manager_user_id: Joi.string().allow(null, ''), // 元請担当者
      crane_id: Joi.string().allow(null, ''), // 揚重機ID
      company_name: Joi.string().allow(null, ''), // 揚重機管理会社名
      operator_name: Joi.string().allow(null, ''), // オペレーター
      spec_form: Joi.string().allow(null, ''), // 性能
      crane_use_id: Joi.string().allow(null, ''), // 揚重機予定Id
      crane_work_contents: Joi.string().allow(null, ''), // 揚重機作業内容
      use_start_time: Joi.string().allow(null, ''), // 揚重機開始時間
      use_end_time: Joi.string().allow(null, ''), // 揚重機終了時間
      crane_spot_flag: Joi.number().allow(null, ''), // スポット作業ON/OFF
      crane_spot_time: Joi.string().allow(null, ''), // スポット時間
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, ''), // 連絡先
      drivers_name: Joi.string()
        .max(255)
        .allow(null, ''), // 運転者名
      control_company_name: Joi.string()
        .max(255)
        .allow(null, ''), // 運用会社名
      memo: Joi.string()
        .max(512)
        .allow(null, ''), // 備考
      work_hour_zone: Joi.string().required(), // 作業時間帯
      schedule_type: Joi.string().required(), // ゲート予定
    };

    if (this.state.isSpot) {
      schema.spot_company_name = Joi.string()
        .max(255)
        .required(); // スポット利用会社名
    } else {
      schema.field_tree_id = Joi.string().required(); // 車輌手配業者
    }

    // 揚重機予定がある場合作業内容必須
    if (values.crane_id !== '') {
      schema.crane_work_contents = Joi.string()
        .max(512)
        .required();
      schema.use_start_time = Joi.string()
        .label('must')
        .required(); // 揚重機開始時間
      schema.use_end_time = Joi.string()
        .label('must')
        .required(); // 揚重機終了時間
    }

    if (useConstructionSiteCodeFlg) {
      if (this.state.isSpot) {
        schema.spot_foreman_user_job = Joi.string()
          .max(255)
          .required();
        schema.spot_foreman_user_name = Joi.string()
          .max(255)
          .required();
      } else {
        schema.job_id = Joi.string().required();
        schema.foreman_user_id = Joi.string().required();
      }
      schema.tel = Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required();
      schema.manager_user_id = Joi.string().required();
      schema.enter_gate_fleet_system_route_id = Joi.string().required();
      schema.exit_gate_fleet_system_route_id = Joi.string().required();
      schema.foreman_user_tel = Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required();
    }

    if (useTrackerFlg) {
      schema.sub_tel = Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, '');
    }

    const result = validateByJoi(Joi.object().keys(schema), values);
    const validate = _.cloneDeep(this.state.validate);
    // エラーメッセージをセット
    if (name) {
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
        validate.invalid = true;
      } else if (name === 'use_start_time' || name === 'use_end_time') {
        delete validate.messages.use_start_time;
        delete validate.messages.use_end_time;
      } else if (validate.messages[name]) {
        delete validate.messages[name];
      }

      if (_.isEqual(name, 'allRoutes') && useConstructionSiteCodeFlg) {
        delete validate.messages['enter_gate_fleet_system_route_id'];
        delete validate.messages['exit_gate_fleet_system_route_id'];
      }

      // 協力会社ユーザーでログイン時、
      // 開始日(From)が現在日より前の日付に設定されていたらエラー
      const today = moment().format('YYYY/MM/DD');
      if (
        isPartnerCompanyRoleId(this.state.roleId) &&
        moment(today, 'YYYY/MM/DD').isAfter(values.passage_date)
      ) {
        validate.messages.passage_date = messageUtility.getMessage('E-001-313');
        validate.invalid = true;
      }
    } else {
      if (!isNullOrEmpty(validate.messages.passage_date)) {
        if (_.has(result, 'messages')) {
          result.messages.passage_date = validate.messages.passage_date;
        } else {
          result.messages = {};
          result.messages.passage_date = validate.messages.passage_date;
        }
      }
      if (_.size(result.messages) > 0) {
        validate.messages = result.messages;
      } else {
        validate.messages = [];
      }
    }
    delete validate.messages['undefined'];
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    } else {
      validate.invalid = true;
    }

    this.setState({ validate });
    // 必須チェック
    this.checkRequired(values);
    return Object.keys(validate.messages).length;
  }

  /**
   * ドロップダウンで選択した揚重機情報をstateへ保存
   * @param name {string}
   * @param value {int}
   */
  setCraneDropdownData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const validate = _.cloneDeep(this.state.validate);
    const pulldownName = _.cloneDeep(this.state.pulldownName);
    formValues.crane_id = value;
    if (value) {
      requiredInput.hasSpot = [
        ...INITIAL_REQUIRED_INPUT_HAS_SPOT,
        ...REQUIRED_INPUT_WITH_CRANE,
      ];
      requiredInput.columns = [
        ...INITIAL_REQUIRED_INPUT_COLUMNS,
        ...REQUIRED_INPUT_WITH_CRANE,
      ];
      if (this.state.useConstructionSiteCodeFlg) {
        requiredInput.hasSpot = [
          ...requiredInput.hasSpot,
          ...REQUIRED_INPUT_WITH_FUTRAL_HAS_SPOT,
        ];
        requiredInput.columns = [
          ...requiredInput.columns,
          ...REQUIRED_INPUT_WITH_FUTRAL,
        ];
      }
      this.setCraneDetails(value);
    } else {
      // 選択解除
      _.each(REQUIRED_INPUT_WITH_CRANE, column => {
        if (formValues[column] !== '') {
          requiredInput.count -= 1;
        }
      });
      formValues.company_name = '';
      formValues.operator_name = '';
      formValues.spec_form = '';
      formValues.crane_use_id = '';
      formValues.crane_work_contents = '';
      formValues.use_start_time = '';
      formValues.use_end_time = '';
      formValues.crane_spot_flag = '';
      formValues.crane_spot_time = '';
      delete validate.messages.crane_work_contents;
      delete validate.messages.use_start_time;
      delete validate.messages.use_end_time;
      requiredInput.hasSpot = [...INITIAL_REQUIRED_INPUT_HAS_SPOT];
      requiredInput.columns = [...INITIAL_REQUIRED_INPUT_COLUMNS];
      if (this.state.useConstructionSiteCodeFlg) {
        requiredInput.hasSpot = [
          ...requiredInput.hasSpot,
          ...REQUIRED_INPUT_WITH_FUTRAL_HAS_SPOT,
        ];
        requiredInput.columns = [
          ...requiredInput.columns,
          ...REQUIRED_INPUT_WITH_FUTRAL,
        ];
      }
      pulldownName.crane_name = '';
    }
    this.setState({ requiredInput, formValues, validate, pulldownName });
  };

  /**
   * 揚重機マスタ情報セット
   * @param craneId {int}
   */
  setCraneDetails(craneId, paramValues = {}) {
    paramValues = {
      ...this.state.formValues,
      ...paramValues,
    };
    let param = {
      field_id: this.state.fieldId,
      work_hour_zone: sessionStorage.getItem('work_hour_zone'),
      use_date_from: paramValues.passage_date,
      use_date_to: paramValues.passage_date,
      crane_id: [craneId],
    };
    const emptyValues = {
      company_name: '',
      operator_name: '',
      spec_form: '',
    };
    // 予定がすでにあればlist_for_crane_usesのデータを使う
    CraneService.listForCraneUses(this.state.fieldId, param).then(response => {
      if (response.result) {
        const crane = response.data.entities.cranes[0];
        if (crane) {
          const formValues = {
            ...this.state.formValues,
            ...emptyValues,
          };
          formValues.company_name = crane.partner_company_name;
          if (
            crane.crane_operator_schedules &&
            crane.crane_operator_schedules.length != 0
          ) {
            formValues.operator_name =
              crane.crane_operator_schedules[0].operator_name;
          }
          formValues.spec_form = crane.spec_form;
          // データ要求時の日時が現在の日時が異なるときは棄却
          if (
            paramValues.use_date_start === formValues.use_date_start &&
            paramValues.use_date_end === formValues.use_date_end
          ) {
            this.setState({ formValues });
          }
        } else {
          // 予定がなければオペレータの情報なしでcraneのマスタデータを使う
          // ゲート予定は登録時点でクレーン予定がなければ連動してクレーン予定を作成するが、
          // ゲート予定編集時点でクレーン予定が必ず存在するわけではなく削除されているケースも存在する
          CraneService.show(this.state.fieldId, craneId).then(response => {
            if (!response.result) {
              return;
            }
            const formValues = {
              ...this.state.formValues,
              ...emptyValues,
            };
            const crane = response.data.entities.crane;
            formValues.company_name = crane.partner_company_name;
            formValues.spec_form = crane.spec_form;
            // データ要求時の日時が現在の日時が異なるときは棄却
            if (
              paramValues.use_date_start === formValues.use_date_start &&
              paramValues.use_date_end === formValues.use_date_end
            ) {
              this.setState({ formValues });
            }
          });
        }
      }
    });
  }

  /**
   * カレンダー日付セット
   * @param name {string}
   * @param date {string}
   */
  setDate = (name, date) => {
    const formValues = _.cloneDeep(this.state.formValues);
    if (formValues[name] !== date) {
      formValues[name] = date;
      if (formValues.crane_id) {
        this.setCraneDetails(formValues.crane_id, { [name]: date });
      }
      this.validateValue(name, { [name]: date });
      this.setState({ formValues });
    }
  };

  /**
   * 入力値をformValuesにセット
   * ドロップダウンで選択したデータをstateへ保存
   * @param name {string}
   * @param value {any}
   */
  setFlatData = (name, value) => {
    const { useConstructionSiteCodeFlg } = this.state;
    this.setState(
      prevState => {
        const formValues = _.cloneDeep(prevState.formValues);
        formValues[name] = _.defaultTo(deleteControlCode(value), '');

        // ゲート予定 の編集画面で
        // 協力会社Dropdownが動作した時に
        // 職種Dropdown 職長Dropdown の初期化が行われる
        // 不具合[BLDE_V2-17211]として、内部値が更新されていない問題があり
        // この箇所で内部値をクリアしておく

        // 車輌手配業者=協力会社:field_tree_id
        // 職種:job_id
        // 職長:foreman_user_id
        if (
          name === 'field_tree_id' &&
          this.state.formValues.field_tree_id !== value
        ) {
          // 協力会社に変更があった場合は、職種|職長の値は初期化される
          formValues.job_id = null;
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        } else if (
          name === 'job_id' &&
          this.state.formValues.job_id !== value
        ) {
          // 職種に変更があった場合は、職長の値は初期化される
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        } else if (_.isEqual(name, 'luggage') && useConstructionSiteCodeFlg) {
          formValues.luggage = value;
        }

        return {
          formValues,
        };
      },
      () => {
        if (
          useConstructionSiteCodeFlg &&
          _.includes(
            [
              'field_tree_id',
              'job_id',
              'foreman_user_id',
              'manager_user_id',
              'luggage',
            ],
            name
          )
        ) {
          this.validateValue(name);
        }
      }
    );
  };

  /**
   * スポット業者設定ハンドリング
   * @param spotFlag {int}
   */
  setSpotFlag = spotFlag => {
    const formValues = _.cloneDeep(this.state.formValues);
    const { useConstructionSiteCodeFlg } = this.state;
    let isSpot = this.state.isSpot;
    const validate = _.cloneDeep(this.state.validate);
    if (spotFlag === SPOT_STATUS.spot.id) {
      formValues.field_tree_id = null;
      formValues.job_id = null;
      formValues.foreman_user_id = null;
      if (validate.messages.field_tree_id) {
        delete validate.messages.field_tree_id;
      }
      if (useConstructionSiteCodeFlg) {
        validate.messages.job_id && delete validate.messages.job_id;
        validate.messages.foreman_user_id &&
          delete validate.messages.foreman_user_id;
      }
      isSpot = true;
    } else if (spotFlag === SPOT_STATUS.normal.id) {
      formValues.spot_company_name = '';
      formValues.spot_foreman_user_job = '';
      formValues.spot_foreman_user_name = '';
      if (validate.messages.spot_company_name) {
        delete validate.messages.spot_company_name;
      }
      if (useConstructionSiteCodeFlg) {
        validate.messages.spot_foreman_user_job &&
          delete validate.messages.spot_foreman_user_job;
        validate.messages.spot_foreman_user_name &&
          delete validate.messages.spot_foreman_user_name;
      }
      isSpot = false;
    }
    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    }

    this.setState(
      {
        formValues,
        isSpot,
        validate,
      },
      () => {
        const values = {};
        _.map(formValues, (value, index) => {
          values[index] = _.isNull(value) ? '' : `${value}`;
        });
        this.checkRequired(values);
      }
    );
  };

  /**
   * スポットフラグ設定
   * @param checked {boolean}
   */
  setSpotStatus = checked => {
    const formValues = _.cloneDeep(this.state.formValues);
    if (checked) {
      formValues.spot_flag = SPOT_STATUS.normal.id;
      formValues.spot_time = '';
    } else {
      formValues.spot_flag = SPOT_STATUS.spot.id;
      formValues.spot_time = SPOT_TIMES_DEFAULT;
    }

    this.setState({ formValues });
  };

  /**
   * 揚重機スポットフラグ設定
   * @param checked {boolean}
   */
  setCraneSpotStatus = checked => {
    const formValues = _.cloneDeep(this.state.formValues);
    if (checked) {
      formValues.crane_spot_flag = SPOT_STATUS.normal.id;
      formValues.crane_spot_time = '';
    } else {
      formValues.crane_spot_flag = SPOT_STATUS.spot.id;
      formValues.crane_spot_time = SPOT_TIMES_DEFAULT;
    }

    this.setState({ formValues });
  };

  setLuggageType = (value) => {
    this.setState(
      prevState => ({
        formValues: {
          ...prevState.formValues,
          luggage: value,
        },
      }),
      () => {
        if (value) {
          this.validateValue('luggage');
        }
      }
    );
  }

  /**
   * フォーム生成
   * @param data {object}
   */
  async initForm(data) {
    // console.log(
    //   'GatePassageEdit.jsx initForm',
    //   Object.keys(data).join(','),
    //   Object.keys(this.state.formValues).join(','),
    //   Object.keys(this.state.pulldownName).join(',')
    // );
    // if (
    //   !parts.object.inProperty(
    //     data,
    //     'id, field_id, field_tree_id, gate_id, gate_name, gate_width, gate_height,' +
    //       'passage_date, today_receipt_no, crane_use_id, crane_id, crane_name, crane_work_contents,' +
    //       'use_start_time, use_end_time, crane_spot_flag, crane_spot_time,' +
    //       'foreman_user_id, foreman_user_name_sei, foreman_user_name_mei,' +
    //       'spot_company_name, spot_foreman_user_name, spot_contact_info,' +
    //       'passage_start_time, passage_end_time, truck_name, drivers_name, tel, luggage, truck_count, status_code,' +
    //       'manager_user_id, manager_user_name_sei, manager_user_name_mei,' +
    //       'control_company_name, memo, work_hour_zone, schedule_type,' +
    //       'spot_time, spot_flag, spot_foreman_user_job, job_id, job_name, approval_flag, created_at, updated_at, company_name ' +
    //       ''
    //   )
    // ) {
    //   throw new Error('GatePassageEdit.jsx initForm data inProperty');
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.formValues,
    //     'userValueChangeFlag,approval_flag,today_receipt_no,passage_date,field_tree_id,' +
    //       'job_id,foreman_user_id,spot_company_name,spot_foreman_user_job,spot_foreman_user_name,' +
    //       'gate_id,status_code,truck_name,truck_count,luggage,passage_start_time,passage_end_time,' +
    //       'spot_flag,spot_time,manager_user_id,crane_id,company_name,operator_name,spec_form,' +
    //       'crane_use_id,crane_work_contents,use_start_time,use_end_time,crane_spot_flag,' +
    //       'crane_spot_time,tel,drivers_name,control_company_name,memo,work_hour_zone,schedule_type' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.formValues inProperty'
    //   );
    // }
    // if (
    //   !parts.object.inProperty(
    //     this.state.pulldownName,
    //     'company_name, job_name, foreman_user_name, gate_name,' +
    //       'manager_user_name, crane_name' +
    //       ''
    //   )
    // ) {
    //   throw new Error(
    //     'GatePassageEdit.jsx initForm this.state.pulldownName inProperty'
    //   );
    // }

    const formValues = {};
    const pulldownName = {};
    const requiredInput = { ...this.state.requiredInput };

    _.each(data, (value, key) => {
      if (_.has(this.state.formValues, key)) {
        formValues[key] = _.defaultTo(value, '');
      }
    });
    formValues.gate_fleet_status = data.gate_fleet_status;
    formValues.id = data.id;
    formValues.lock_version = data.lock_version;
    if (this.state.useTrackerFlg) {
      const { sub_tel, transportation_group_id } = data.gate_passages_tracker;
      const { fieldId, companyId } = this.state;
      const params = {
        field_id: fieldId,
        id: transportation_group_id,
        company_id: companyId,
      };
      let itemTransportation = null;
      if (transportation_group_id) {
        const response = await GatePassageService.getListTransportationGroups(
          fieldId,
          params
        );
        const transportationGroupData = _.get(
          response,
          'data.entities.transportation_groups'
        );
        itemTransportation = _.find(
          transportationGroupData,
          item => item.id === transportation_group_id
        );
      } else {
        formValues.transportation_group_id = '';
      }
      formValues.sub_tel = sub_tel;
      if (itemTransportation) {
        formValues.transportation_group_id = transportation_group_id;
        pulldownName.transportation_group_name = itemTransportation.name;
      }
    }
    // 移行データ用初期化処理
    if (formValues.field_tree_id === 0) {
      formValues.field_tree_id = null;
    }
    if (isNullOrEmpty(formValues.schedule_type)) {
      formValues.schedule_type = SCHEDULE_TYPES.gate.id;
    }

    // プルダウンの名前の初期値を取得
    if (!data.spot_company_flag) {
      // スポットの場合はnameに設定しない
      pulldownName.company_name = data.company_name; // 協力会社名
    }

    // プルダウンの名前の初期値を取得
    pulldownName.job_name = data.job_name; // 職名
    pulldownName.foreman_user_name = data.foreman_user_name_sei
      ? `${data.foreman_user_name_sei} ${data.foreman_user_name_mei}`
      : ''; // 職長名
    pulldownName.gate_name = data.gate_name; // ゲート名
    pulldownName.manager_user_name = `${data.manager_user_name_sei}${
      data.manager_user_name_mei
    }`; // 元請担当者名(sei,meiを結合)
    pulldownName.crane_name = data.crane_name; // 使用揚重機名

    // 揚重機詳細
    if (data.crane_id) {
      requiredInput.hasSpot = [
        ...INITIAL_REQUIRED_INPUT_HAS_SPOT,
        ...REQUIRED_INPUT_WITH_CRANE,
      ];
      requiredInput.columns = [
        ...INITIAL_REQUIRED_INPUT_COLUMNS,
        ...REQUIRED_INPUT_WITH_CRANE,
      ];
      if (this.state.useConstructionSiteCodeFlg) {
        requiredInput.hasSpot = [
          ...requiredInput.hasSpot,
          ...REQUIRED_INPUT_WITH_FUTRAL_HAS_SPOT,
        ];
        requiredInput.columns = [
          ...requiredInput.columns,
          ...REQUIRED_INPUT_WITH_FUTRAL,
        ];
      }
      this.setCraneDetails(data.crane_id, formValues);
    }

    const today = moment().format('YYYY/MM/DD');
    let viewOnlyFlag = false;
    // 協力会社ユーザーの場合、現在日付がpassage_dateより後の日付 || 他社の予定は編集不可とする
    if (
      (isPartnerCompanyRoleId(this.state.roleId) &&
        moment(today).isAfter(formValues.passage_date)) ||
      (_.has(data, 'permissions') && data.permissions.edit === false)
    ) {
      viewOnlyFlag = true;
    }

    this.setState(
      {
        formValues,
        requiredInput,
        pulldownName,
        viewOnlyFlag,
        isFirstLoaded: true,
        isSpot: data.spot_company_flag,
        limitTruckCount: formValues.truck_count,
      },
      () => {
        this.checkRequired(formValues);
      }
    );
  }

  /**
   * 登録
   */
  update = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    let validateResult = this.validateValue();
    if (validateResult !== 0) {
      this.updatingFlag = false;
      return;
    }
    const { useTrackerFlg, formValues } = this.state;
    const values = useTrackerFlg
      ? formValues
      : _.omit(this.state.formValues, ['sub_tel', 'transportation_group_id']);
    GatePassageService.update(
      this.state.fieldId,
      this.state.gatePassageId,
      values
    ).then(response => {
      if (response.result === false) {
        if (isWorkDateError(response.message)) {
          const validate = { ...this.state.validate };
          validate.messages.passage_date = response.message;
          validate.invalid = true;
          this.setState({ validate });
        } else {
          const isConcurrentTracker = isConcurrentErrorTracker(
            response.message
          );
          if (
            isPrimeContractorHasBlockedOrFinishedWorkError(response.message) ||
            isConcurrentTracker
          ) {
            return dialogLoader.show(FormInformationDialog, {
              title: isConcurrentTracker
                ? undefined
                : messageUtility.getMessage('E-001-422'),
              message: messageUtility.getMessage(
                isConcurrentTracker ? 'E-001-459' : 'E-001-423'
              ),
              buttonText: isConcurrentTracker
                ? messageUtility.getMessage('I-000-180')
                : undefined,
              onClose: () => {
                window.location.reload();
              },
            });
          }
          if (isEditConcurrentErrorGate(response)) {
            return dialogLoader.show(FormInformationDialog, {
              title: messageUtility.getMessage('E-001-402'),
              message: messageUtility.getMessage('E-001-436'),
              onClose: () => {
                window.location.reload();
              },
            });
          }
          dialogLoader.show(ErrorDialog, {
            message: response.message,
            callback: {
              close: () => {
                dialogLoader.close();
              },
            },
          });
        }
        this.updatingFlag = false;
        return;
      }
      if (values.crane_id) {
        GatePassageService.addCraneUse(
          this.state.fieldId,
          this.state.gatePassageId,
          values
        ).then(response => {
          if (response.result === false) {
            if (response.message) {
              const validate = { ...this.state.validate };
              validate.messages.passage_date = response.message;
              validate.invalid = true;
              this.setState({ validate });
            }
            this.updatingFlag = false;

          }
        });
      }
      _slideLoader.close(this.props.vw);
      EventMg.trigger(MY_EVENT.LOAD_GATE_PASSAGES_DATA);

      this.updatingFlag = false;
    });
  };

  /**
   * ゲート予定削除
   */
  deleteGatePassage() {
    GatePassageService.deleteSchedule(
      this.state.fieldId,
      this.state.gatePassageId
    ).then(response => {
      if (response.result) {
        _slideLoader.close(this.props.vw);
        EventMg.trigger(MY_EVENT.LOAD_GATE_PASSAGES_DATA);
      }
    });
  }

  /**
   * 入力値をformValuesにセット
   * @param pair {string}
   */
  setTime = (e, pair) => {
    const selectedIndex = e.target.selectedIndex;
    const selected = e.target.options[selectedIndex];
    const selectedDate = selected.getAttribute('data-select');
    const target = moment(selectedDate);
    const formValues = _.cloneDeep(this.state.formValues);
    const name = e.target.name;
    const value = e.target.value;
    formValues[name] = value;
    if (name === 'passage_start_time' || name === 'use_start_time') {
      if (!formValues[pair]) {
        formValues[pair] = target.add(15, 'minutes').format('HH:mm:ss');
      } else {
        const endSelect = document.getElementById(`gate-passages-${pair}`);
        const endIndex = endSelect.selectedIndex;
        const endSelected = endSelect.options[endIndex];
        const end = moment(endSelected.getAttribute('data-select'));
        if (end.isSameOrBefore(target)) {
          formValues[pair] = target.add(15, 'minutes').format('HH:mm:ss');
        }
      }
    } else if (name === 'passage_end_time' || name === 'use_end_time') {
      if (!formValues[pair]) {
        formValues[pair] = target.add(-15, 'minutes').format('HH:mm:ss');
      } else {
        const startSelect = document.getElementById(`gate-passages-${pair}`);
        const startIndex = startSelect.selectedIndex;
        const startSelected = startSelect.options[startIndex];
        const start = moment(startSelected.getAttribute('data-select'));
        if (start.isSameOrAfter(target)) {
          formValues[pair] = target.add(-15, 'minutes').format('HH:mm:ss');
        } else if (formValues[pair] === 'Invalid date') {
          formValues[pair] = target.add(-15, 'minutes').format('HH:mm:ss');
        }
      }
    }
    this.setState({ formValues });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} dialogName ダイアログ名(DIALOG_NAME)
   *                            ※ nullの場合は、ダイアログを閉じる
   */
  handleVisibleDialog(dialogName) {
    this.setState({ visibleDialogName: dialogName });
  }

  setRouteIn = (id, value) => {
    const { formValues, validate } = this.state;
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          enter_gate_fleet_system_route_id: id,
          exit_gate_fleet_system_route_id: formValues.exit_gate_fleet_system_route_id
            ? formValues.exit_gate_fleet_system_route_id
            : id,
          enter_gate_fleet_system_route_name: value,
          exit_gate_fleet_system_route_name: formValues.exit_gate_fleet_system_route_name
            ? formValues.exit_gate_fleet_system_route_name
            : value,
        },
      },
      () => {
        if (
          validate.messages['enter_gate_fleet_system_route_id'] &&
          validate.messages['exit_gate_fleet_system_route_id']
        ) {
          this.validateValue('allRoutes');
        } else if (validate.messages['exit_gate_fleet_system_route_id']) {
          this.validateValue('exit_gate_fleet_system_route_id');
        } else {
          this.validateValue('enter_gate_fleet_system_route_id');
        }
      }
    );
  };

  setRouteOut = (id, value) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          exit_gate_fleet_system_route_id: id,
          exit_gate_fleet_system_route_name: value,
        },
      },
      () => {
        this.validateValue('exit_gate_fleet_system_route_id');
      }
    );
  };

  render() {
    const {
      visibleDialogName,
      formValues,
      isFirstLoaded,
      viewOnlyFlag,
      useConstructionSiteCodeFlg,
    } = this.state;

    // console.log(
    //   'GatePassageEdit.jsx render',
    //   'pulldownName',
    //   this.state.pulldownName
    // );
    const pageTitle =
      formValues.approval_flag === APPROVAL_STATUS.approval.id
        ? '承認済ゲート予定'
        : 'ゲート予定編集';
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - {pageTitle}
          </title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            title={<div className='slide-view__title'>{pageTitle}</div>}
            leftComponent={
              formValues.approval_flag !==
              APPROVAL_STATUS.unapproved
                .id ? null : !isFirstLoaded ? null : viewOnlyFlag ? null : (
                <React.Fragment>
                  <button
                    id='open-confirm-close'
                    className='btn--effective slide-view__header--button'
                    onClick={() => this.events.form.update()}
                  >
                    更新
                  </button>
                  <button
                    id='open-confirm-close'
                    className='btn--negative slide-view__header--button'
                    onClick={() => this.handleVisibleDialog(DIALOG_NAME.delete)}
                  >
                    削除
                  </button>
                  {useConstructionSiteCodeFlg && (
                    <div className='slide-view__header-end-item'>
                      <span className='text--negative'>
                        {_.isNull(formValues.gate_fleet_status) &&
                          messageUtility.getMessage('E-000-067')}
                        {isStatusRejectGateFutral(
                          formValues.gate_fleet_status
                        ) && formValues.gate_fleet_message}
                      </span>
                    </div>
                  )}
                </React.Fragment>
              )
            }
            rightComponent={
              <React.Fragment>
                <div className='slide-view__header-end-item'>
                  <div className='form-list__header-alert show'>
                    {this.state.validate.invalid
                      ? '入力エラーがあります。'
                      : ''}
                  </div>
                </div>
                <div className='slide-view__header-end-item'>
                  {`必須項目の入力数 ${this.state.requiredInput.count}/${
                    this.state.isSpot
                      ? _.size(this.state.requiredInput.hasSpot)
                      : _.size(this.state.requiredInput.columns)
                  }`}
                </div>
              </React.Fragment>
            }
            onClose={() => {
              if (formValues.approval_flag !== APPROVAL_STATUS.unapproved.id) {
                _slideLoader.close(this.props.vw);
              } else {
                this.handleVisibleDialog(DIALOG_NAME.close);
              }
              useConstructionSiteCodeFlg
                ? EventMg.trigger(MY_EVENT.LOAD_GATE_PASSAGES_DATA)
                : null;
            }}
          />
          <GatePassageForm
            roleId={this.state.roleId}
            isEdit={true}
            isSpot={this.state.isSpot}
            isSpotToggle={this.state.isSpotToggle}
            values={formValues}
            errors={this.state.validate.messages}
            workTime={this.state.workTime}
            viewOnlyFlag={
              formValues.approval_flag === APPROVAL_STATUS.approval.id ||
              viewOnlyFlag
            }
            events={this.events}
            pulldownName={this.state.pulldownName}
            useConstructionSiteCodeFlg={this.state.useConstructionSiteCodeFlg}
            useTrackerFlg={this.state.useTrackerFlg}
            setRouteIn={this.setRouteIn}
            setRouteOut={this.setRouteOut}
            fieldId={this.state.fieldId}
            limitTruckCount={this.state.limitTruckCount}
          />
        </div>
        <Confirmation
          title={messageUtility.getMessage('I-000-025')}
          visible={visibleDialogName === DIALOG_NAME.close}
          message={messageUtility.getMessage('I-000-confirmCloseEditWindow')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={() => {
            _slideLoader.close(this.props.vw);
            EventMg.trigger(MY_EVENT.LOAD_GATE_PASSAGES_DATA, true);
          }}
          onCancel={() => this.handleVisibleDialog(null)}
          negativeButtonClassName='btn--negative'
          cancelButtonClassName='btn--sub'
        />
        <Confirmation
          visible={visibleDialogName === DIALOG_NAME.delete}
          title={messageUtility.getMessage(
            'I-001-302',
            SCHEDULE_TYPES.gate.name
          )}
          message={messageUtility.getMessage('W-000-003')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={() => {
            this.deleteGatePassage();
          }}
          onCancel={() => this.handleVisibleDialog(null)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GatePassageEdit.jsx